/* noted. — Skipstone portal copy, and one placement CSS cannot do.

   Awtomic's portal strings resolve through Shopify locale keys under
   'awtomatic.customer_portal' in locales/en.default.json. That file is the
   proper home for the swaps below. It is a 37KB auto-generated file the API
   can only replace wholesale, so rewriting it by hand to change a handful of
   phrases is a worse risk than this is. These swaps are the interim.

   MOVE THESE TO THE LOCALE FILE when there is a calm window. The keys are:
     subscription.your_next_order   tables.quantity   bundles.edit_my_box
     bundles.build_box / build_your_box   subscription.update_bundle
     tables.box_discount   bundles.box_size
   Online Store > Themes > Edit default theme content reaches all of them.

   SAFETY. The walker rejects script and style outright, and every entry point
   is wrapped. Awtomic ships inline script on this page, and rewriting a string
   inside their own source is how a copy swap turns into a dead app. */
(function () {
  "use strict";
  if (window.location.pathname.indexOf("/tools/bundle-subscriptions") === -1) return;

  var HEADING_SEL = ".bundle-details-table-title, .skipstone-flourished";
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEMPLATE: 1, TEXTAREA: 1 };

  var SWAPS = [
    { re: /Your next order/i, to: "Your Upcoming Allocation" },
    { re: /\s*[•·∙]\s*/, to: " ", headingOnly: true },
    { re: /^\s*Edit my box\s*$/i, to: "Customize My Allocation", flourish: true },
    { re: /^\s*Customize my box\s*$/i, to: "Customize My Allocation", flourish: true },
    { re: /^\s*Build your box\s*$/i, to: "Compose Your Allocation", flourish: true },
    { re: /^\s*Update Box\s*$/i, to: "Update Allocation" },
    { re: /^\s*Quantity\s*$/i, to: "Qty" },
    { re: /^\s*Box size\s*$/i, to: "Allocation size" },
    { re: /^\s*Box discount\s*$/i, to: "Allocation discount" }
  ];

  function run() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p || SKIP_TAGS[p.nodeName]) return NodeFilter.FILTER_REJECT;
        if (p.classList && p.classList.contains("skipstone-minimum-note")) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var n;
    while ((n = w.nextNode())) {
      var p = n.parentNode;
      for (var i = 0; i < SWAPS.length; i++) {
        var s = SWAPS[i];
        if (s.headingOnly && !(p.closest && p.closest(HEADING_SEL))) continue;
        if (!s.re.test(n.nodeValue)) continue;
        n.nodeValue = n.nodeValue.replace(s.re, s.to);
        if (s.flourish && p.classList) p.classList.add("skipstone-flourished");
        break;
      }
    }
    relabelEdit();
    placeCustomize();
    clearLegacyPadding();
  }

  /* The membership row's control opens the allocation builder, not a field
     edit. Scoped to that row so every other Edit keeps its own word. */
  function relabelEdit() {
    var row = document.querySelector(".bundle-table__body-row--bab-parent");
    if (!row) return;
    Array.prototype.forEach.call(row.querySelectorAll("button"), function (b) {
      if (/^\s*(edit|customized)\s*$/i.test(b.textContent)) {
        if (b.textContent !== "Customize") b.textContent = "Customize";
        b.classList.add("skipstone-customize");
      }
    });
  }

  /* CUSTOMIZE, ON THE MEMBERSHIP ROW, UNDER TOTAL.

     It ships in a FIFTH cell on that row. The wine rows have four, and under
     table-layout:fixed the column widths come from the first row, where the
     four declared percentages already add to 100. The fifth column therefore
     had no width and its contents spilled over the cards to the right.

     CSS can hide that cell but cannot move a button out of it, so the button
     is relocated here into the row's FOURTH cell, the total column.

     An earlier version parked it in the table foot. Wrong line. Any foot row
     that version created is removed on sight.

     Guarded on parentNode so repeated passes cannot re-append, and re-checked
     every pass so an Awtomic repaint that rebuilds the row puts it back
     rather than losing it. */
  function placeCustomize() {
    var btn = document.querySelector("button.skipstone-customize");
    if (!btn) return;

    var stale = document.querySelector("tr.skipstone-customize-row");
    if (stale && !stale.contains(btn)) stale.parentNode.removeChild(stale);

    var row = document.querySelector(".bundle-table__body-row--bab-parent");
    if (!row || row.cells.length < 4) return;

    var host = row.cells[3];
    if (host && btn.parentNode !== host) host.appendChild(btn);

    if (stale && stale.parentNode && !stale.contains(btn)) {
      stale.parentNode.removeChild(stale);
    }
  }

  /* An earlier version padded the breadcrumb by measurement to meet the
     centred heading. It was solving the wrong problem and is gone. Any inline
     padding it left behind is cleared here. */
  function clearLegacyPadding() {
    var crumb = document.querySelector(".bundle-flex-container");
    if (crumb && crumb.style.paddingLeft) crumb.style.paddingLeft = "";
  }

  function safeRun() {
    try { run(); } catch (e) { console.warn("[skipstone-portal-copy]", e); }
  }

  /* NEVER requestAnimationFrame HERE. rAF does not fire in a hidden or
     backgrounded tab, so the queued flag latches true and the observer goes
     deaf for the rest of the page's life. This file shipped with an rAF
     debounce and, in a background tab, made only the two timed passes below.
     Same fault found and fixed in skipstone-bundle-order.js and
     skipstone-portal-pricing.js. A timer runs either way. */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; safeRun(); }, 50);
  }

  function start() {
    try {
      safeRun();
      new MutationObserver(schedule).observe(document.body, {
        childList: true, subtree: true, characterData: true
      });
      [200, 800, 1600, 2200, 3500, 6000].forEach(function (ms) {
        setTimeout(safeRun, ms);
      });
    } catch (e) {
      console.warn("[skipstone-portal-copy] disabled", e);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
